import { ofType } from 'redux-observable';
import { switchMap } from 'rxjs';

import { replaceCardOnboardingMaterial } from '@perpay-web/fintech/actions/ui/cardOnboardingMaterial';
import * as metalSteps from '@perpay-web/fintech/constants/steps/cardOnboardingMetalSteps';
import { reduxStepsSetStep } from '@perpay-web/hooks/useReduxSteps';
import { dispatchObservable } from '@perpay-web/observable/dispatchObservable';

export const cardOnboardingMetalReplaceMaterial = (action$, state$) =>
    action$.pipe(
        ofType(replaceCardOnboardingMaterial().type),
        switchMap(() =>
            dispatchObservable({
                action$,
                state$,
                initialDispatch: () => [
                    reduxStepsSetStep(
                        Object.values(metalSteps),
                        metalSteps.REVIEW_AND_SUBMIT_TERMS_AND_CONDITIONS_STEP,
                    ),
                ],
            }),
        ),
    );
